import Pagination from '../../../components/layout/Pagination'
import Photo from '../../../components/Photo'
import firstPhoto from '../../../assets/video/vans/IMG_0072.png'
import secondPhoto from '../../../assets/video/vans/IMG_0073.png'
import thirdPhoto from '../../../assets/video/vans/IMG_0074.png'
import fourthPhoto from '../../../assets/video/vans/IMG_0075.png'
import fifthPhoto from '../../../assets/video/vans/IMG_0076.png'
import sixthPhoto from '../../../assets/video/vans/IMG_0077.png'
import seventhPhoto from '../../../assets/video/vans/IMG_0078.png'
import eighthPhoto from '../../../assets/video/vans/IMG_0079.png'

function Vans() {
    return (
        <>
            <div className="contents-wrapper">
                <h2 className='font-sawarabiMincho'>◼︎ VANS - THIS IS OFF THE WALL</h2>
                <div className='top-video-container'>
                    <iframe width="100%" src="https://www.youtube.com/embed/TBUmEYAliq8?si=JKidzWSfN7arVQ_r" title="YouTube video player" frameBorder="0" allowFullScreen></iframe>
                </div>
                <div className='photo-wrapper'>
                    <div className='col left-col'>
                        <Photo src={firstPhoto} />
                        <Photo src={thirdPhoto} />
                        <Photo src={fifthPhoto} />
                        <Photo src={seventhPhoto} />
                    </div>
                    <div className='col right-col'>
                        <Photo src={secondPhoto} />
                        <Photo src={fourthPhoto} />
                        <Photo src={sixthPhoto} />
                        <Photo src={eighthPhoto} />
                    </div>
                </div>
                <div className='credit-wrapper'>
                    <p>
                        VANS - THIS IS OFF THE WALL<br />
                        <br />
                        Director: Masaki Watanabe<br />
                        <br />
                    </p>
                </div>
            </div>
            <Pagination nextLink='/video/commercial/wacoal' />
        </>
    )
}

export default Vans